import * as React from 'react'
import { Flex } from '@radix-ui/themes'
import { Section } from '../section'
import { styles } from './styles.css'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'

type Props = {
  ref: React.RefObject<HTMLElement>
}

export const FeaturesSection: React.FC<Props> = ({ ref }) => {
  return (
    <Section id="features" title="FEATURES" subtitle="3つの特徴" className={styles.section} ref={ref}>
      <Flex direction="column" align="center" gap="48px" pt="16px" pb="24px">
        <Flex direction="column" align="center" gap="24px">
          <img className={styles.image} src={image1} />
          <Flex direction="column" align="center" gap="16px" px="24px">
            <h3 className={styles.heading}>
              旬の花を贅沢に使った
              <br />
              たっぷりボリューム
            </h3>
            <p className={styles.text}>
              毎月お届けするブーケは12本入り。ダイニングテーブルや玄関に飾って華やかに見えるサイズ感です。複数の花器に分けてお家のいろいろな場所に飾るのもおすすめ。
              <br />
              <br />
              今しか出会えない花たちが、お家の中でも季節を感じさせてくれます。
            </p>
          </Flex>
        </Flex>
        <Flex direction="column" align="center" gap="24px">
          <img className={styles.image} src={image2} />
          <Flex direction="column" align="center" gap="16px" px="24px">
            <h3 className={styles.heading}>
              専属フローリストが
              <br />
              「かわいい」を保証します
            </h3>
            <p className={styles.text}>
              毎月届くブーケは、お花のことを熟知した専属フローリストがデザイン。
              季節感はもちろん、色合いや咲き方、シルエットなど、部屋に飾ったときのことを想像してバランスよく組み合わせます。
              <br />
              <br />
              どんな花が届くかは、箱を開けるまでのお楽しみ。届いたまま飾るだけで気分も空間も整う、そんなブーケを月に1回お届けします。
            </p>
          </Flex>
        </Flex>
        <Flex direction="column" align="center" gap="24px">
          <img className={styles.image} src={image3} />
          <Flex direction="column" align="center" gap="16px" px="24px">
            <h3 className={styles.heading}>
              仕入れてすぐ発送
              <br />
              鮮度にとことんこだわります
            </h3>
            <p className={styles.text}>
              新鮮さは花の命。FLOWERはこれまで100万束以上のブーケを届けてきた実績があります。市場で仕入れたてのお花たちをすぐに発送。ご自宅までフレッシュな状態でお届けします。
              <br />
              <br />
              もし万が一届いたお花に元気がなかった場合の補償もご用意しておりますので、ご安心ください。️
            </p>
          </Flex>
        </Flex>
      </Flex>
    </Section>
  )
}
